export default __webpack_public_path__ + "static/media/54.4f1456ab.jpg";